<div class="contact-sales-form-skeleton" aria-hidden="true">
  @for (field of [1, 2, 3, 4, 5]; track field) {
  <div class="contact-sales-form-skeleton-field">
    <wp-skeleton height="16px" [width]="'28%'" [loading]="true"></wp-skeleton>
    <wp-skeleton height="48px" [width]="'100%'" [loading]="true"></wp-skeleton>
  </div>
  }
  <wp-skeleton height="48px" [width]="'132px'" [loading]="true"></wp-skeleton>
</div>
